import { render } from "./AddDomain.vue?vue&type=template&id=c09607de"
import script from "./AddDomain.vue?vue&type=script&lang=js"
export * from "./AddDomain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__